/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import legacy_jquery from 'jquery';
import status from '@bingads-webui-static-legacy/schema/bulkEdit/status';
import resultsStatus from '@bingads-webui-static-legacy/schema/bulkEdit/resultsStatus';
import StatusPoller from '@bingads-webui-static-legacy/bulk-edit/bulkEdit/jobStatePoller';
import cacheManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import filterConverter from '@bingads-webui-static-legacy/odata-filter-converter';
import * as filterMetadataToLegacy from '@bingads-webui/filter-commons';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import * as _AppEventDelegator from '@bingads-webui-component-legacy/app-event-delegator/index';
import blockerExtension from '@bingads-webui-static-legacy/extension/promise/withUiBlock';
import repository from '@bingads-webui-static-legacy/bulk-edit/bulkEdit/bulkEditRepository';
import errorMapper from '@bingads-webui-static-legacy/api-error-mapper-service';
import gridFilterSerializer from '@bingads-webui-campaign-legacy/bulk-operation/util/grid-filter-serializer';
import * as toast from '@bingads-webui-component-legacy/toast/index';
import gridHelper from '@bingads-webui-static-legacy/shared/view/gridHelper';
import cacheService from '@bingads-webui-static-legacy/bulk-edit-cache-service';
import actionMap from '@bingads-webui-static-legacy/summary/SummaryGridsActionMap';
import PageContext from '@bingads-webui-static-legacy/page-context';
import legacyRouter from '@bingads-webui-component-legacy/legacy-router/index';
import setting from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import logger from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import appState from '@bingads-webui-component-legacy/state/index';
import '@bingads-webui-static-legacy/instrumentation/instrumentation';
var osd = window.osd;
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var activePollers = 0;
var AppEventDelegator = _AppEventDelegator.default;
var vNextCacheNotify = function vNextCacheNotify(context, skipEntityCallPaths) {
  var entity = context.model.get('Entity');
  cacheManager.successEmitter.trigger('invalidate', entity, skipEntityCallPaths);
};
var onProgressNotification = function () {
  var currentStatus = this.model.get('Status');
  if (currentStatus === status.pendingStart || currentStatus === 'PendingFileUpload') {
    return;
  }
  var totalCount = this.model.get('TotalRowCount');
  var successCount = this.model.get('SuccessRowCount');
  var errorCount = this.model.get('ErrorRowCount');
  this.ko_model.totalCount(totalCount);
  this.ko_model.successCount(successCount);
  this.ko_model.errorCount(errorCount);
  if (_.isFunction(this.getProgressText)) {
    this.ko_model.statusText(this.getProgressText().replace('{1}', totalCount).replace('{0}', successCount + errorCount));
  }
  if (currentStatus === status.completed) {
    if (activePollers > 0) {
      activePollers -= 1;
      this.onJobSuccess(this.model);
      this.refresh();
      this.refreshGrid();
    }
    vNextCacheNotify(this);
  } else if (currentStatus === status.completedWithErrors) {
    this.ko_model.completedWithErrorsBulkEditResultsString(i18n.getString('CampaignAdGroupCopyPaste_CompletedWithErrorsText_NewUI'));
    activePollers -= 1;
    this.onJobFailure();
    this.showErrors();
    this.ko_model.showButtonBar(false);
    this.ko_model.showCloseButton(true);
    if (this.model.get('SuccessRowCount') > 0) {
      gridHelper.refresh(this.grid);
      this.refreshGrid();
    }
    vNextCacheNotify(this);
  } else if (currentStatus === status.failed && this.operationCancelled) {
    activePollers -= 1;
    this.refresh();
  } else if (currentStatus === status.failed) {
    activePollers -= 1;
    if (!this.handleUserError()) {
      legacy_jquery.advertiser.ajaxError();
    }
  }
};
var getDateRangeQueryArgs = function () {
  try {
    var dateRange;
    if (!!osd && !!osd.ui && !!osd.ui.Controls && !!osd.ui.Controls.DateRangeFilter && _.isFunction(osd.ui.Controls.DateRangeFilter.getParsedDateRange)) {
      dateRange = osd.ui.Controls.DateRangeFilter.getParsedDateRange();
    } else {
      dateRange = window.App && window.App.state ? window.App.state.get('$daterange') : null;
    }
    var startdate = dateRange.start.getMonth() + 1 + '/' + dateRange.start.getDate() + '/' + dateRange.start.getFullYear(), enddate = dateRange.end.getMonth() + 1 + '/' + dateRange.end.getDate() + '/' + dateRange.end.getFullYear();
    return 'startdate=' + startdate + '&enddate=' + enddate;
  } catch (e) {
    return '';
  }
};
var view = Backbone.View.extend({
  initialize: function (options) {
    this.poller = new StatusPoller({
      success: _.bind(onProgressNotification, this),
      error: function () {
        legacy_jquery.advertiser.ajaxError();
      }
    });
    this.grid = options.grid;
    this.isSkipEntityCache = options.isSkipEntityCache;
    this.onOperationSuccess = options.onOperationSuccess;
    this.onOperationFailure = options.onOperationFailure;
    this.instrumentationActivity = options.activity;
    this.eventDelegator = _.result({}, 'eventDelegator', new AppEventDelegator());
  },
  render: function () {
    this.$el.html(this.template({
      i18n: i18n,
      PageContext: PageContext,
      viewModel: this.ko_model,
      isForVNext: true
    }));
    if (this.$el.length > 0) {
      ko.cleanNode(this.$el[0]);
    }
    ko.applyBindings(this.ko_model, this.$el[0]);
    _.bindAll(this, 'submitJob', 'previewChanges', 'hideView', 'hideProgress', 'cancelJob', 'stopCopyPaste');
    this.$('#save').click(this.submitJob);
    this.$('#preview').click(this.previewChanges);
    this.$('#cancel').click(this.cancelJob);
    this.$('#runInBackground').click(this.hideProgress);
    this.$('#close').click(this.hideView);
    this.$('#stopCopyPaste').click(this.stopCopyPaste);
    var link = 'javascript:void(0);';
    this.$('#historyPageLink').attr('href', link);
    var firstVisibleEnabledElement = this.$el.find(':input:enabled:visible:first');
    if (_.isFunction(firstVisibleEnabledElement.focus)) {
      firstVisibleEnabledElement.focus();
    }
    return this;
  },
  events: function () {
    return {
      'click a#historyPageLink': function () {
        legacyRouter.legacyRouter.navigateToRoute('bulk_edit');
      }
    };
  },
  hideView: function () {
    this.$el.empty();
    gridHelper.onBulkEditViewHide(this, this.grid);
  },
  hideProgress: function () {
    this.$el.empty();
    cacheService.init();
    gridHelper.onBulkEditViewHide(this, this.grid);
  },
  stopCopyPaste: function () {
    this.showPreview(false);
    var cId = PageContext.CurrentCustomer.Id;
    var aId = PageContext.CurrentAccount.Id;
    var sessionId = this.model.get('Id');
    var url = '/Customers(' + cId + ')/Accounts(' + aId + ')/BulkEditSessions(\'' + sessionId + '\')/Default.Cancel';
    odata.get(url, {
      data: null
    }).catch(function () {
      return null;
    });
    this.operationCancelled = true;
  },
  getCurrentFilter: function () {
    var filters = {}, idBased = false;
    if (!this.ko_model.ignoreRowSelection() && gridHelper.allPageSelected(this.grid)) {
      if (this.grid && (this.grid.filterService || this.grid.pgridPlugins && this.grid.pgridPlugins.filterService)) {
        var filterServiceFilters = (this.grid.filterService || this.grid.pgridPlugins.filterService).getCombinedFilter();
        filters.FilterExpressions = filterMetadataToLegacy.toLegacyFilter(filterServiceFilters);
      } else if (this.grid && this.grid.pgridPlugins) {
        if (this.grid.pgridPlugins.filterState) {
          var pluginFilters = this.grid.pgridPlugins.filterState.getAllFilters();
          filters.FilterExpressions = filterMetadataToLegacy.toLegacyFilter(pluginFilters);
        } else if (this.grid.pgridPlugins.filter) {
          var pluginFilters = this.grid.pgridPlugins.filter.getCurrentFilter();
          filters.FilterExpressions = filterMetadataToLegacy.toLegacyFilter(pluginFilters);
        }
      } else {
        filters = this.grid.getFilters(true);
      }
    } else if (_.isFunction(this.getIdFilter)) {
      idBased = true;
      filters = this.getIdFilter();
      if (this.grid && (this.grid.filterService || this.grid.pgridPlugins && this.grid.pgridPlugins.filterService)) {
        filterServiceFilters = (this.grid.filterService || this.grid.pgridPlugins.filterService).getCombinedFilter();
        var additionalFilterExpressions = filterMetadataToLegacy.toLegacyFilter(filterServiceFilters);
        if (additionalFilterExpressions && additionalFilterExpressions.length >= 2 && additionalFilterExpressions[0]['SelectedColumn'] === 'Criterion' && additionalFilterExpressions[1]['SelectedColumn'] === 'LevelOfDetails') {
          filters.FilterExpressions = _.union(additionalFilterExpressions, filters.FilterExpressions);
        }
      }
    }
    if (_.isFunction(this.getCustomFilter)) {
      var customFilter = this.getCustomFilter(filters) || ({
        FilterExpressions: []
      });
      if (filters && filters.FilterExpressions) {
        filters.FilterExpressions = _.union(filters.FilterExpressions, customFilter.FilterExpressions);
      } else {
        filters = {
          FilterExpressions: customFilter.FilterExpressions
        };
      }
    }
    return {
      FilterExpressions: filters && filters.FilterExpressions || [],
      idBased: idBased
    };
  },
  getFilterURLParam: function (filter, entity) {
    return filterConverter.convertToURLParam(filter.FilterExpressions, entity);
  },
  getCurrentSelection: function (simulateResults) {
    var entity = this.model.get('Entity');
    var query = null, campaignId = -1, adGroupId = -1, dateRangeQs = null, filter = this.getCurrentFilter();
    if (this.ko_model.ignoreRowSelection()) {
      if (_.isFunction(this.getCampaignId)) {
        campaignId = this.getCampaignId();
      }
      if (_.isFunction(this.getAdGroupId)) {
        adGroupId = this.getAdGroupId();
      }
      if (_.isFunction(this.getDateRangeQuery)) {
        dateRangeQs = this.getDateRangeQuery();
      }
    } else {
      campaignId = Number(legacy_jquery.advertiser.getUrlParameter('cmpid')) || Number(appState.get('campaign_id'));
      adGroupId = Number(legacy_jquery.advertiser.getUrlParameter('adgid')) || Number(appState.get('adgroup_id'));
      dateRangeQs = getDateRangeQueryArgs();
    }
    if (simulateResults) {
      var pageSize = gridHelper.getPageSize(this.grid);
      var currentPage = gridHelper.getCurrentPage(this.grid);
      var sortInfo = gridHelper.getSortInfo(entity, this.grid);
      query = '$top=' + pageSize + '&$skip=' + currentPage * pageSize + '&$orderby=' + sortInfo;
    }
    if (filter) {
      var addendum = dateRangeQs ? dateRangeQs : '';
      var filterURLParam = this.getFilterURLParam(filter, entity);
      if (filterURLParam) {
        if (addendum) {
          addendum += '&';
        }
        addendum += filterURLParam;
      }
      query = query === null ? addendum : query + '&' + addendum;
    }
    return {
      'QueryString': query,
      'CampaignId': campaignId > 0 ? campaignId : null,
      'AdGroupId': adGroupId > 0 ? adGroupId : null
    };
  },
  onJobSuccess: function (model) {
    if (_.isFunction(this.onOperationSuccess)) {
      this.onOperationSuccess(model);
    }
  },
  onJobFailure: function (model) {
    if (_.isFunction(this.onOperationFailure)) {
      this.onOperationFailure(model);
    }
  },
  onValidateFailure: function () {},
  refresh: function () {
    gridHelper.refresh(this.grid, this.hideView.bind(this));
  },
  submitJob: function () {
    this.showPreview(false);
    this.makeChanges(false);
  },
  cancelJob: function () {
    this.hideView();
  },
  previewChanges: function () {
    this.makeChanges(true);
  },
  isValuesArrayEmpty: function (filterExpressions) {
    var isEmpty = false;
    if (filterExpressions.length > 0) {
      _.each(filterExpressions, function (item) {
        if (item.Values.length === 0) {
          isEmpty = true;
        }
      });
    }
    return isEmpty;
  },
  makeChanges: (function (simulateResults) {
    activePollers = 0;
    if (this.ko_model.ignoreRowSelection() || this.hasSelectedEntities()) {
      if (this.ko_model.validate(this)) {
        if (!simulateResults) {
          this.ko_model.isDisabled(true);
        }
        this.model.unset('PreviewEntityIds');
        if (simulateResults) {
          this.model.url = 'Advertiser/Customers()/Accounts()/BulkEditSessions?$expand=BulkEditResults&preview=true';
          if (gridHelper.allPageSelected(this.grid)) {
            this.model.set('PreviewEntityIds', gridHelper.getSelectedEntityIds(this.grid));
          }
        } else {
          var isCustomerLevelLabel = this._scope && this._scope === 'Customer';
          var accountValueInUrl = isCustomerLevelLabel ? '' : 'Accounts()/';
          this.model.url = 'Advertiser/Customers()/' + accountValueInUrl + 'BulkEditSessions?';
        }
        if (_.isFunction(this.setAction)) {
          this.setAction(simulateResults);
        }
        this.model.set('Selection', this.getCurrentSelection(simulateResults));
        var currentFilter = this.getCurrentFilter();
        if (currentFilter.idBased && this.isValuesArrayEmpty(currentFilter.FilterExpressions)) {
          this.refresh();
          return;
        }
        if (!currentFilter.idBased && (_.contains(currentFilter.FilterExpressions, null) || _.contains(currentFilter.FilterExpressions, undefined))) {
          try {
            logger.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'bulkeditsessions/makeChanges/nullFilter', JSON.stringify({
              BatchAction: this.model.get('BatchAction'),
              filter: currentFilter
            }));
          } catch (ex) {}
        }
        this.model.set('Description', gridFilterSerializer.toDescription(currentFilter));
        legacy_jquery.advertiser.clearErrorSummary();
        if (actionMap) {
          actionMap.registerActionMapExtension('bulkeditsessions', _.bind(this.model.updateSummaryDataContext, this.model));
        }
        this.model.save({}, {
          success: _.bind(function (model) {
            let skipEntityCallPaths = null;
            if (this.isSkipEntityCache && currentFilter.idBased && currentFilter.FilterExpressions.length > 0) {
              const entityName = this.model.get('Entity');
              skipEntityCallPaths = _.flatten(_.map(currentFilter.FilterExpressions, filterExpressions => _.map(filterExpressions.Values, value => `${entityName}s(${value})`)));
            }
            vNextCacheNotify(this, skipEntityCallPaths);
            if (this.model.attributes.BatchAction.Actions) {
              _.each(this.model.attributes.BatchAction.Actions, function (element, index) {
                if (element['@odata.type'] === '#Model.TextAction' && element.ActionType === 'Set' && element.Property === 'Status' && element.Value === 'Excluded') {
                  logger.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'bulkeditsessions/AudienceBulkEditExclusion', '{"result": "1"}');
                } else if (element['@odata.type'] === '#Model.AudienceAssociationAction' && element.AssociationList && element.ExclusionList) {
                  logger.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'bulkeditsessions/AdgroupAudienceExclusionList', '{"result": "1", "AssociationList": "' + element.AssociationList.length + '", "ExclusionList": "' + element.AssociationList.length + '"}');
                }
              });
            }
            var currentStatus = model.get('Status');
            if (model.url && model.url.toLowerCase().indexOf('preview=true') > 0) {
              this.ko_model.totalCount(model.get('TotalRowCount'));
              var results = model.get('BulkEditResults');
              if (_.isFunction(this.formatPreviewResults)) {
                results = this.formatPreviewResults(results, model);
              }
              this.ko_model.currentPageChangeCount(results.length);
              this.ko_model.results(results);
              this.showPreview(true);
            } else if (currentStatus === status.pendingStart || currentStatus === 'PendingFileUpload') {
              this.showProgress(true);
              this.ko_model.showCheckBoxes(false);
              this.ko_model.showButtonBar(false);
              activePollers += 1;
              this.poller.start(model);
            } else if (currentStatus === status.completed) {
              this.onJobSuccess(model);
              this.refresh();
            } else if (currentStatus === status.completedWithErrors) {
              this.onJobFailure(model);
              this.ko_model.errorCount(this.model.get('ErrorRowCount'));
              this.showErrors();
              this.ko_model.showButtonBar(false);
              this.ko_model.showCloseButton(true);
              if (this.model.get('SuccessRowCount') > 0) {
                gridHelper.refresh(this.grid);
              }
              if (this.ko_model.showPanel === false) {
                gridHelper.onBulkEditViewHide(this, this.grid);
              }
            }
            if (this.instrumentationActivity && _.isFunction(this.instrumentationActivity.stop)) {
              this.instrumentationActivity.stop();
            }
          }, this),
          error: _.bind(function (model, response) {
            if (this.model.attributes.BatchAction.Actions) {
              _.each(this.model.attributes.BatchAction.Actions, function (element, index) {
                if (element['@odata.type'] === '#Model.TextAction' && element.ActionType === 'Set' && element.Property === 'Status' && element.Value === 'Excluded') {
                  logger.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'bulkeditsessions/AudienceBulkEditExclusion', '{"result": "0"}');
                } else if (element['@odata.type'] === '#Model.AudienceAssociationAction' && element.AssociationList && element.ExclusionList) {
                  logger.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'bulkeditsessions/AdgroupAudienceExclusionList', '{"result": "0", "AssociationList": "' + element.AssociationList.length + '", "ExclusionList": "' + element.AssociationList.length + '"}');
                }
              });
            }
            var errors = response && response.responseJSON && response.responseJSON.value || [];
            if (_.isEmpty(errors) || !errors[0] || !errors[0].Code) {
              legacy_jquery.advertiser.ajaxError();
            } else {
              var code = errors[0].Code;
              var msg = errorMapper.mapCampaignApiErrorCodeShort(code) || errorMapper.mapCampaignApiErrorCode(code);
              legacy_jquery.advertiser.clearErrorSummary();
              legacy_jquery.advertiser.appendErrorSummary(msg);
            }
          }, this)
        }).withUiBlock();
      } else {
        this.onValidateFailure();
      }
    } else {
      alert(i18n.getString('Grid_RowSelectionRequired'));
    }
  }).asLoggingStart(setting.ACTIVITYNAME.BulkEditSessions, setting.SCENARIONAME.BulkEditSessions),
  showProgress: function (visibility) {
    this.ko_model.showProgress(visibility);
  },
  showPreview: function (visibility) {
    this.ko_model.showPreview(visibility);
  },
  showErrors: function () {
    repository.getJobResults(this.model.get('Id'), resultsStatus.OnlyErrors, 0, this.ko_model.maxInlineErrorCount, this.model.get('Entity')).withUiBlock().done(_.bind(function (response) {
      if (response && response.value) {
        _.each(response.value, function (item) {
          item.combinedErrors = this.localizeErrors(item);
        }, this);
        if (_.isFunction(this.formatErrors)) {
          response.value = this.formatErrors(response.value, this.model);
        }
        this.ko_model.inlineErrors(response.value);
      }
      this.ko_model.showProgress(false);
      this.ko_model.showErrors(true);
      this.$('.errorCountLink').off('click');
      this.$('.errorCountLink').click(_.bind(function () {
        this.ko_model.showErrorGrid(!this.ko_model.showErrorGrid());
      }, this));
      if (!_.isFunction(this.onOperationFailure) && !gridHelper.allPageSelected(this.grid)) {
        this.toastErrors();
      }
    }, this)).fail(legacy_jquery.advertiser.ajaxError);
  },
  refreshGrid: function () {
    if (PageContext.CurrentTabId == 'Campaign') {
      cacheManager.getContext('/campaign/NewCampaign/Create?');
      this.eventDelegator && this.eventDelegator.trigger('campaignReload');
    } else if (PageContext.CurrentTabId == 'AdGroup') {
      cacheManager.getContext('/campaign/MewAdGroup/Create?');
      this.eventDelegator && this.eventDelegator.trigger('adGroupReload');
    }
  },
  toastErrors: function () {
    var inlineErrors = _.map(this.ko_model.inlineErrors(), function (error) {
      return error.combinedErrors;
    });
    var toastErrors = new Set();
    _.each(inlineErrors, function (errors) {
      _.each(errors, function (error) {
        toastErrors.add(error);
      });
    });
    toastErrors.forEach(function (error) {
      toast.showError(error);
    });
  },
  handleUserError: function () {
    var userErrors = this.model.get('UserErrors');
    var customColumnErrors = _.chain(userErrors).map(function (userError) {
      if (userError.Code === 'CustomColumnIdIsInvalid') {
        return {
          ErrorCode: 'EntityDoesNotExist',
          Id: userError.Property.replace('CustomColumn', '')
        };
      }
      if (userError.Code === 'CustomColumnIsUnsupported') {
        return {
          ErrorCode: 'EntityIsUnsupported',
          Id: userError.Property.replace('CustomColumn', '')
        };
      }
      return null;
    }).compact().value();
    if (_.isEmpty(customColumnErrors)) {
      return false;
    }
    if (this.grid.gridView) {
      this.grid.gridView.trigger('hasInvalidOrDeletedCustomColumns', customColumnErrors);
    }
    this.onJobFailure();
    this.ko_model.showProgress(false);
    this.ko_model.showButtonBar(false);
    this.ko_model.showCloseButton(true);
    this.refreshGrid();
    window.App.views.alertCenter.toastWarning(i18n.getString('BulkEdit_Notification_CustomColumn_Errors'));
    return true;
  },
  updateSelectedEntityCount: function (count) {
    this.ko_model && this.ko_model.selectedEntityCount(count);
  },
  localizeErrors: function (entityResult) {
    var apiErrorMessages = _.isArray(entityResult.Errors) ? _.map(entityResult.Errors, function (error) {
      return errorMapper.mapCampaignApiErrorCodeShort(error) || errorMapper.mapCampaignApiErrorCode(error);
    }) : [], editorialErrors = _.isArray(entityResult.EditorialErrors) ? errorMapper.mapEditorialErrors(entityResult.EditorialErrors, true) : [];
    if (_.isFunction(this.transformErrors)) {
      this.transformErrors(editorialErrors);
    }
    var editorialErrorMessages = _.map(editorialErrors, function (error) {
      return i18n.getString('BulkEdit_HistoryJobDetails_EditorialError', error.countryName, error.message);
    });
    return apiErrorMessages.concat(editorialErrorMessages);
  },
  hasSelectedEntities: function () {
    var selectedRowIds = gridHelper.getSelectedRowIds(this.grid);
    return _.isArray(selectedRowIds) ? selectedRowIds.length > 0 : false;
  }
});
export default view;

